export const affecteTo = [
    { name: 'BY_VEHICULE', label: 'Quelques véhicules' },
    { name: 'BY_GROUPS', label: 'Groupe de véhicules' },
    { name: 'ALL_VEHICULE', label: 'Tous les véhicules' }

  ];
